import { useState, useEffect } from 'react';
import globalStyles from '../App.module.scss';
import styles from './paymentSummary.module.scss';

interface DiscountProps {
    hasError: boolean;
    onValidateClick: (inputText: string) => void;
}

function Discount({ hasError, onValidateClick }: DiscountProps) {
    const [discountIsOpen, setDiscountIsOpen] = useState(false);
    const [inputText, setInputText] = useState('');

    useEffect(() => {
        setDiscountIsOpen(hasError);
    }, [hasError]);

    function toggleDiscount() {
        setDiscountIsOpen((discountIsOpen) => !discountIsOpen);
    }

    function ValidateDiscountCodeBtnClick(event: React.MouseEvent<HTMLButtonElement>, inputText: string) {
        event?.preventDefault();
        onValidateClick(inputText);
    }

    function ValidateDiscountCodeInputEvent(event: React.KeyboardEvent<HTMLInputElement>, inputText: string) {
        event?.preventDefault();
        onValidateClick(inputText);
    }

    return (
        <div className={styles.discount}>
            {discountIsOpen && (
                <div>
                    <div className={styles.lblDiscountCode}>Rabattkode</div>
                    <input
                        type="text"
                        className={styles.inputDiscountCode}
                        id="discountcode"
                        name="discountcode"
                        autoFocus={true}
                        onChange={(e) => setInputText(e.currentTarget.value)}
                        onKeyDown={(e) => {
                            e.key === 'Enter' && ValidateDiscountCodeInputEvent(e, inputText);
                        }}
                    ></input>
                    {hasError && <div className={styles.discountError}>Rabattkoden er ikke gyldig</div>}
                    <button
                        className={[globalStyles.sideActionButton, styles.btnDiscountCode].join(' ')}
                        onClick={(e) => ValidateDiscountCodeBtnClick(e, inputText)}
                    >
                        Løs inn rabattkode
                    </button>
                </div>
            )}

            {!discountIsOpen && (
                <button className={styles.btnToggleDiscount} onClick={toggleDiscount}>
                    + Legg til rabattkode
                </button>
            )}
        </div>
    );
}

export default Discount;
